"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { ProviderType } from "@/types/dataProvider";
import type { BaseProviderFormProps } from "./base-provider-form";

export const QuickbooksProviderForm = (_props: BaseProviderFormProps) => {
	return null;
};

(QuickbooksProviderForm as any).providerType = ProviderType.QUICKBOOKS;
